import {
  logEvent,
  EVENT_PARAM_TYPE_STRING,
  EVENT_PARAM_TYPE_INTEGER,
} from '@artemis/utils/analytics';

const EVENT_ACTION_LOCATIONS_PAGE_IMPRESSION =
  'MERCHANT_GROUP_LOCATION_PAGE_IMPRESSION';

export const logImpression = (groupId, merchantGroup) => {
  const ids = merchantGroup.map(merchant => merchant.id).join('|');
  const names = merchantGroup.map(merchant => merchant.name).join('|');

  logEvent(EVENT_ACTION_LOCATIONS_PAGE_IMPRESSION, [
    {
      key: 'MERCHANT_GROUP_ID',
      value: groupId,
      type: EVENT_PARAM_TYPE_STRING,
    },
    {
      key: 'MERCHANT_IDS',
      value: ids,
      type: EVENT_PARAM_TYPE_STRING,
    },
    {
      key: 'MERCHANT_NAMES',
      value: names,
      type: EVENT_PARAM_TYPE_STRING,
    },
    {
      key: 'NUMBER_OF_MERCHANTS',
      value: merchantGroup.length,
      type: EVENT_PARAM_TYPE_INTEGER,
    },
  ]);
};
